
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexFjODQcXRHARbL6xySYWCAmoRPOlfiuEvLjnaENlNxY0Meta } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/index.vue?macro=true";
import { default as contact0hUYxzT4KVCSOVuftsJRHAqm4IUZKmLRzFuimr11VbEMeta } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/contact.vue?macro=true";
import { default as mentions_45legalesFF2_45ijDqnCM11xIOd5P5hGMINoBQwqNCGXZJH7khFccMeta } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/mentions-legales.vue?macro=true";
import { default as domaine_45de_45competenceskVhGe7qeiFCOKYzejurjldI8DNDb418PDe4L_45sJuELwMeta } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/domaine-de-competences.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/contact.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/mentions-legales.vue")
  },
  {
    name: "domaine-de-competences",
    path: "/domaine-de-competences",
    component: () => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/domaine-de-competences.vue")
  }
]